export default __webpack_public_path__ + "static/media/news.1098a01e.png";